var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg023Dislike(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.9999 17H7.9999V21C7.99912 21.8625 8.55133 22.6283 9.3699 22.9C9.57362 22.9651 9.78605 22.9988 9.9999 23C10.6259 22.9969 11.2143 22.7008 11.5899 22.2L15.4499 17H17.9999C18.5522 17 18.9999 16.5523 18.9999 16V7C18.9999 6.44772 18.5522 6 17.9999 6H7.2499C6.06523 6.00029 4.99167 6.69771 4.5099 7.78L2.2599 12.85C1.85013 13.7699 1.93795 14.8353 2.49282 15.6757C3.0477 16.5162 3.99295 17.0154 4.9999 17ZM4.1299 13.67L6.3399 8.59C6.50099 8.23164 6.857 8.00082 7.2499 8H16.9999V15H14.9999C14.6851 15 14.3888 15.1482 14.1999 15.4L9.9999 21V16C9.9999 15.4477 9.55218 15 8.9999 15H4.9999C4.67967 15.0039 4.38044 14.8411 4.2099 14.57C4.01469 14.3123 3.96559 13.9724 4.0799 13.67H4.1299ZM19.9999 16V7C19.9999 6.44772 20.4476 6 20.9999 6C21.5522 6 21.9999 6.44772 21.9999 7V16C21.9999 16.5523 21.5522 17 20.9999 17C20.4476 17 19.9999 16.5523 19.9999 16Z",
    fill: "#8199A6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg023Dislike);
export default __webpack_public_path__ + "static/media/023-dislike.512ec13ec261be508084f1033da5843d.svg";
export { ForwardRef as ReactComponent };